export default [
	{ diamonds: 0, type: "character", slug: "fish" },
	{ diamonds: 50, type: "character", slug: "spider" },
	{ diamonds: 200, type: "character", slug: "barrel" },
	{ diamonds: 500, type: "character", slug: "carrot" },
	{ diamonds: 900, type: "character", slug: "wolf" },
]